<template>
	<div>
		<template v-for="(data, channel) in channels">
			<k-layout style="padding-top: 0px; padding-top: 5px; padding-bottom: 5px;">
				<k-flex c3>
						<channel-title :channel="get_channel(channel)" :alternative="get_alternative(channel)"></channel-title>
				</k-flex>
				<k-flex c2>
						{{get_source_state(data).state}}
				</k-flex>
				<k-flex c1>
						{{get_port(data, "source")}}
				</k-flex>
				<k-flex c1>
						{{get_port(data, "output")}}
				</k-flex>
				<k-flex c5>
							<template v-for="(info, ip) in get_dest_state(data)">
								<k-chip size="xs" :color="get_color_for_state(info.status.state)" style="height: 20px;">
									{{ip}}&nbsp;
								 	 <k-sparkline line-width="1px" fill width="200" style="width: 50px;" padding="8px" :value="get_buffer_history(info.status)">
								 	 </k-sparkline>
								  	 <div>&nbsp;C:{{get_buffer_status(info.status)}}/M:{{get_max_history(info.status)}}</div>
								</k-chip>
							</template>
				</k-flex>
			</k-layout>
			<k-divider></k-divider>
		</template>
	</div>
</template>

<script>

import ChannelModel from '@/models/channel.js';
import ChannelTitle from '@/components/ChannelTitle.vue';


export default {
	props: ["id"],
	components: {
		ChannelTitle
	},
	methods: {
		get_channel(uuid) {
        	var channel_uuid = uuid.split(":")[0];
			return ChannelModel.channel_by_uuid(channel_uuid);
		},
		get_alternative(uuid) {
			return uuid.split(":")[1] || "";
		},
		get_buffer_status(data) {
			if (typeof(data != "undefined")) {
				if (typeof(data.info) != "undefined") {
					return data.info.buffer_status.current_length;
				}				
			}
			return "";
		},
		get_buffer_history(data) {
			if (typeof(data != "undefined")) {
				if (typeof(data.info) != "undefined") {
					if (typeof(data.info.buffer_status.history) != "undefined") {
						return _.map(data.info.buffer_status.history, (data) => {
							return data; //[1];
						});
					}
				}				
			}
			return [];
		},
		get_max_history(data) {
			var history = this.get_buffer_history(data);
			return _.max(history);	
		},
		get_state(data, type) {
			var i = data.instance;
			if (typeof(i) != "undefined") {
				var s = i[type];
				if (typeof(s) != "undefined") {
					return s;
				}
			}
			return;
		},
		get_color_for_state (state) {
      		if (state == "listening") return "primary";
      		if (state == "disconnected") return "danger"
      		if (state == "connecting") return "warning";
      		if (state == "connected") return "success";
      		return undefined;
    	},

		get_source_state(data) {
			return this.get_state(data, "source");
		},
		get_dest_state(data) {
			return this.get_state(data, "destinations")
		},
		get_port(data, type) {
			var st = this.get_state(data, type)
			if (typeof(st) != "undefined") {
				var info = st.info;
				if (typeof(info) != "undefined") {
					return info.port;
				}
			}
			return;
		}
	},
	computed: {
		channels () {
			var st = ChannelModel.status_all();
			if (typeof(st) != "undefined") {
				var ret = {}
				_.each(st, (data, id) => {
					if (data.headend_instance == this.id) {
						ret[id] = data;
					}
				});
				return ret;
			}
			return {};
		}
	}
}
</script>